/** Immutable Set toggle for selection signals: returns a copy with `key` added or removed. */
export const toggleInSet = (cur: Set<string>, key: string): Set<string> => {
  const next = new Set(cur);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  return next;
};
